import { lazy, Suspense } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import RootLayout from "./layouts/RootLayout";
// import { AuthProvider } from './context/AuthContext'

import Home from "./pages/Home";
import EventDetail from "./pages/EventDetail/EventDetail";
import CreateEvent from "./pages/CreateEvent";

import EventManagement from "./layouts/EventManagement";
import ManageEvent from "./components/EventManagement/ManageEvent";
import ManageEventAttendees from "./components/EventManagement/ManageEventAttendees";
import ManageEventRegistration from "./components/EventManagement/ManageEventRegistration";
import ManageEventOptions from "./components/EventManagement/ManageEventOptions";
// import ManageEventCommunications from './components/EventManagement/ManageEventCommunications'
import EditEvent from "./components/EditEvent";
import HostedEvents from "./layouts/HostedEvents";
import MyEventsOrganized from "./pages/HostedEvents/MyEventsOrganized";
// import MyEventsEnrolled from './pages/MyEvents/MyEventsEnrolled'
import MyEventsAttendees from "./pages/HostedEvents/MyEventsAttendees";
import MyEventsSettings from "./pages/HostedEvents/MyEventsSettings";
import Agenda from "./layouts/Agenda";
import Signin from "./pages/Signin";
import VerifyEmail from "./pages/VerifyEmail";
import LoginWithToken from "./components/LoginWithToken";
import CompleteProfile from "./pages/CompleteProfile";
import StripeConnectionSuccess from "./pages/StripeConnectionSucces";
import StripeOAuthSuccess from "./pages/StripeOAuthSuccess";
import StripeOAuthError from "./pages/StripeOAuthError";
import UserSettingsRoute from "./pages/UserSettingsRoute";
import UserProfileLayout from "./layouts/UserProfileLayout";
import UserEvents from "./pages/UserProfile/UserEvents";
import UserProfile from "./pages/UserProfile/UserProfileMobile";
import UserGarage from "./pages/UserProfile/UserGarage";
import UserNotifications from "./pages/UserProfile/UserNotifications";
import UserConnections from "./pages/UserProfile/UserConnections";
import PeopleDiscovery from "./pages/PeopleDiscovery";
import EditProfile from "./pages/EditProfile";
import EditInterests from "./pages/EditInterests";
import { EventProvider } from "./context/EventContext";
import { VehicleProvider } from "./context/VehicleContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminGuard from "./components/AdminGuard";
import AdminLayout from "./layouts/AdminLayout";
import AdminInvoices from "./pages/AdminInvoices";
import AdminInvoiceDetail from "./pages/AdminInvoices/AdminInvoiceDetail";
import AdminInvoiceAlerts from "./pages/AdminInvoices/AdminInvoiceAlerts";
import "react-toastify/dist/ReactToastify.css";
import { userProfileLoader } from "./loaders/userProfileLoader";
import { Navigate } from "react-router-dom";
import { isOrganizerAnalyticsUiEnabled } from "./config/analyticsFeatureFlags";

const EventMetricsPage = lazy(() => import("./pages/EventMetricsPage"));
const OrganizerStatisticsPage = lazy(
	() => import("./pages/OrganizerStatisticsPage"),
);

const router = createBrowserRouter(
	[
		{
			element: <RootLayout />,
			children: [
				{ path: "/", element: <Home /> },
				{ path: "/discover", element: <Home /> },
				{ path: "/events/:id/:slug", element: <EventDetail /> },

				// --- Rutas Protegidas ---
				{
					element: <ProtectedRoute />, // Envuelve las rutas que requieren autenticación
					children: [
						{ path: "/create-event", element: <CreateEvent /> },
						{
							path: "/complete-profile",
							element: (
								<VehicleProvider>
									<CompleteProfile />
								</VehicleProvider>
							),
						}, // Ruta protegida
						{
							path: "/hosted-events",
							element: <HostedEvents />,
							children: [
								{ index: true, element: <MyEventsOrganized /> },
								// { path: 'enrolled', element: <MyEventsEnrolled /> },
								{ path: "people", element: <MyEventsAttendees /> },
								{ path: "settings", element: <MyEventsSettings /> },
								...(isOrganizerAnalyticsUiEnabled
									? [
											{
												path: "statistics",
												element: (
													<Suspense fallback={null}>
														<OrganizerStatisticsPage />
													</Suspense>
												),
											},
										]
									: []),
							],
						},
						{
							path: "/agenda",
							element: (
								<EventProvider>
									<Agenda />
								</EventProvider>
							),
						},
						{ path: "/people", element: <PeopleDiscovery /> },
						{
							path: "/user/:userId/notifications",
							element: <UserNotifications />,
						},
						{ path: "/user/:userId/connections", element: <UserConnections /> },
						{ path: "/user/:userId/settings", element: <UserSettingsRoute /> },
						{
							path: "/stripe-connection-success",
							element: <StripeConnectionSuccess />,
						}, // Y esta
						{ path: "/stripe-oauth-success", element: <StripeOAuthSuccess /> },
						{ path: "/stripe-oauth-error", element: <StripeOAuthError /> },
						{
							path: "/events/manage/:id",
							element: <EventManagement />,
							children: [
								{ index: true, element: <ManageEvent /> },
								{ path: "attendees", element: <ManageEventAttendees /> },
								{ path: "registration", element: <ManageEventRegistration /> },
								{ path: "options", element: <ManageEventOptions /> },
								...(isOrganizerAnalyticsUiEnabled
									? [
											{
												path: "metrics",
												element: (
													<Suspense fallback={null}>
														<EventMetricsPage />
													</Suspense>
												),
											},
										]
									: []),
								// { path: 'communications', element: <ManageEventCommunications /> },
							],
						},
						{ path: "/events/manage/:id/edit", element: <EditEvent /> },
						{
							path: "/user/:userId/complete-profile",
							element: (
								<VehicleProvider>
									<CompleteProfile />
								</VehicleProvider>
							),
						},
						// {
						//   path: '/user/:userId/edit-profile',
						//   element: (
						//     <VehicleProvider>
						//       <CompleteProfile />
						//     </VehicleProvider>
						//   )
						// },
						{
							path: "/edit-profile",
							element: (
								<VehicleProvider>
									<EditProfile />
								</VehicleProvider>
							),
						},
						{
							path: "/edit-interests",
							element: (
								<VehicleProvider>
									<EditInterests />
								</VehicleProvider>
							),
						},
						{
							path: "/stripe-connection-success",
							element: <StripeConnectionSuccess />,
						},
					],
				},
				// { path: '/create-event', element: <CreateEvent /> },

				// ——— PERFIL DE USUARIO con loader ———
				{
					path: "/user/:userId",
					element: <UserProfileLayout />,
					loader: userProfileLoader,
					// errorElement: <ProfileError/>,
					children: [
						{
							index: true,
							element: (
								<EventProvider>
									<UserEvents />
								</EventProvider>
							),
						},
						// { path: 'profile', element: <UserProfile /> },
						{
							path: "/user/:userId/profile",
							element: (
								<VehicleProvider>
									<UserProfile />
								</VehicleProvider>
							),
						},
						{
							path: "garage",
							element: (
								<VehicleProvider>
									<UserGarage />
								</VehicleProvider>
							),
						},
						{
							path: "garage",
							element: (
								<VehicleProvider>
									<UserGarage />
								</VehicleProvider>
							),
						},
					],
				},

				{ path: "/signin", element: <Signin /> },
				{ path: "/email-verification", element: <VerifyEmail /> },
				{ path: "/login-with-token", element: <LoginWithToken /> },

				// --- Panel Admin (Motorik) ---
				// Real authorization happens server-side via `requireMotorikAdmin`
				// middleware on /api/admin/* endpoints. AdminGuard here is UX only.
				{
					element: <AdminGuard />,
					children: [
						{
							element: <AdminLayout />,
							children: [
								{
									path: "/admin",
									element: <Navigate to="/admin/invoices" replace />,
								},
								{ path: "/admin/invoices", element: <AdminInvoices /> },
								{
									path: "/admin/invoices/:id",
									element: <AdminInvoiceDetail />,
								},
								{
									path: "/admin/invoice-alerts",
									element: <AdminInvoiceAlerts />,
								},
							],
						},
					],
				},
			],
		},
	],
	{
		future: {
			v7_relativeSplatPath: true,
			v7_fetcherPersist: true,
			v7_normalizeFormMethod: true,
			v7_partialHydration: true,
			v7_skipActionErrorRevalidation: true,
		},
	},
);

//
export default function App() {
	return (
		<RouterProvider router={router} future={{ v7_startTransition: true }} />
	);
}
